module.exports = __webpack_public_path__ + "static/media/picture_help.410726e3.png";